<template>
  <div class="top-categories" v-if="data.active === 'Y'">
    <header class="top-categories__header">
      <h3 class="top-categories__title" v-if="data.show_title === 'Y'">{{ title }}</h3>
      <div class="top-categories__navigation">
        <div class="swiper-button-prev top-categories__prev" slot="button-prev"></div>
        <div class="swiper-button-next top-categories__next" slot="button-next"></div>
      </div>
    </header>
    <swiper class="swiper" :options="swiperOption" v-if="items">
      <swiper-slide class="swiper-item" v-for="(item, i) in items" :key="i">
        <a :href="item.link" class="top-categories__item">
          <span class="top-categories__img-wrap">
            <img :src="isMobile ? item.image_mob : item.image" :alt="item.name">
          </span>
          <span class="top-categories__item-title">{{ item.name }}</span>
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { mapGetters } from 'vuex'
import { isTouch } from '@/mixins/isTouchDevice'

export default {
  name: 'TopCategoriesBlock',
  data () {
    return {
      windowWidth: window.innerWidth,
      swiperOption: {
        watchSlidesVisibility: true,
        spaceBetween: 20,
        slidesPerView: 1.8,
        navigation: {
          prevEl: '.top-categories__prev',
          nextEl: '.top-categories__next'
        },
        simulateTouch: !isTouch,
        touchStartPreventDefault: false,
        preloadImages: false,
        lazy: true,
        breakpoints: {
          600: {
            slidesPerView: 3
          },
          1024: {
            slidesPerView: 4
          }
        }
      }
    }
  },
  mixins: [isTouch],
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['isUkLanguage']),
    title () {
      return this.data[`title_${this.isUkLanguage ? 'uk' : 'ru'}`]
    },
    items () {
      return this.data?.data
    },
    isMobile () {
      return this.windowWidth < 768
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  }
}
</script>

<style lang="sass">
.top-categories .swiper-wrapper
  align-items: flex-start
</style>
<style scoped lang="sass">
@import "../../../node_modules/swiper/css/swiper.min.css"
@import "../../styles/swiper/swiper"
.top-categories
  padding: 0 15px
  &__header
    display: flex
    flex-flow: row wrap
    align-items: baseline
    width: 100%
    margin: 0 0 15px 0
    +mmin($tablet)
      width: auto
      margin: 0 0 30px 0

  &__img-wrap
    position: relative
    padding-top: 114%
    width: 100%
    margin-bottom: 14px
    border-radius: 10px
    overflow: hidden
    +mmin($tablet)
      padding-top: 54%
      margin-bottom: 20px
    +mbetween($tablet--hor, $large)
      padding-top: 80%
    img
      position: absolute
      left: 50%
      top: 50%
      transform: translate(-50%, -50%)
      width: 100%
      height: 100%
      object-fit: cover
      transition: transform 0.5s

  &__item
    display: flex
    flex-direction: column
    align-items: center
    justify-content: stretch
    &-title
      color: #2E2E2E
      text-align: center
      font-size: 14px
      font-style: normal
      font-weight: 500
      line-height: normal
      +mmin($tablet--hor)
        font-size: 18px
    &:hover
      .top-categories__img-wrap img
        transform: translate(-50%, -50%) scale(1.05)

  &__title
    margin: 0
    font-size: 18px
    font-weight: 500
    +mmin($tablet)
      font-size: 24px

  &__navigation
    display: none
    position: relative
    width: 70px
    margin-left: auto
    +mmin($tablet)
      display: block

</style>
